<template>
  <div class="leftBar">
    <div :class="['leftBtnWrap', activeIndex=='basic'?'active':'']" @click="goWeb('basic')">
      <i class="el-icon-setting"></i>
      <span>基础</span>
    </div>
    <div :class="['leftBtnWrap', activeIndex=='view'?'active':'']" @click="goWeb('view')">
      <i class="el-icon-view"></i>
      <span>视角</span>
    </div>
    <div :class="['leftBtnWrap', activeIndex=='hotpoint'?'active':'']" @click="goWeb('hotPoint')">
      <i class="el-icon-warning-outline"></i>
      <span>热点</span>
    </div>
    <div :class="['leftBtnWrap', activeIndex=='sandtable'?'active':'']" @click="goWeb('sandTable')">
      <i class="el-icon-location-outline"></i>
      <span>沙盘</span>
    </div>
    <div :class="['leftBtnWrap', activeIndex=='model'?'active':'']" @click="goWeb('model')">
      <i class="el-icon-office-building"></i>
      <span>模型</span>
    </div>
    <div :class="['leftBtnWrap', activeIndex=='music'?'active':'']" @click="goWeb('music')">
      <i class="el-icon-office-building"></i>
      <span>音乐</span>
    </div>
  </div>
</template>
<style scoped>
  .leftBar{
    position: relative;
    -webkit-box-flex: 0;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    display: flex;
    flex: 0 0 50px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    background-color: #333;
    color: #fff;
  }
  .leftBtnWrap{
    width: 50px;
    height: auto;
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
    margin-top: 5px;
  }
  .leftBtnWrap.active{
    background-color: #427afb;
  }
   .leftBtnWrap.active span{
    color: #fff;
  }
   .leftBtnWrap.active i{
    color: #fff;
  }
  .leftBtnWrap i{
    font-size: 24px;
    display: block;
    margin-bottom: 2px;
    color:#aaaaaa;
  }
  .leftBtnWrap span{
    font-size: 12px;
    display: block;
    color:#aaaaaa;
  }
</style>
<script>
export default {
  name: '',
  components: {
  },
  props: [
    'activeIndex',
    'hasInfos'
  ],
  data() {
    return {
    }
  },
  created() {

  },
  methods: {
    goWeb(str) {
      if(this.nowActiveIndex !== str) {
        if(this.hasInfos) {
          this.$parent.goweb(str)
        }else{
          this.$notify({
            title: '提示',
            message: '数据初始化中，请稍后',
            duration: 1000,
            type: 'info'
          })
        }
      }
    }
  }
}
</script>
